import React, { useState, useRef, useEffect } from "react";
import { Box } from "@mui/material";
import { StyledTooltip } from "./Tooltip.js";
import "moment-timezone";
import "react-intl";
import "../label/EmptyLabel.js";
import "../label/LabelHoc.js";
import "./AutoAdjustedWidthTooltip.styles.js";
import { useAutoAdjustedComplexTooltipClasses } from "./AutoAdjustedComplexTooltip.styles.js";
import "./MultiLineAutoAdjustedWidthTooltip.js";
const AutoAdjustedComplexTooltip = ({ value, tooltip }) => {
  const { classes } = useAutoAdjustedComplexTooltipClasses();
  const [isOverflowed, setIsOverflow] = useState(false);
  const hiddenAbsoluteElementRef = useRef(null);
  const visibleElementRef = useRef(null);
  useEffect(() => {
    if (visibleElementRef?.current && hiddenAbsoluteElementRef?.current) {
      setIsOverflow(hiddenAbsoluteElementRef.current.clientWidth > visibleElementRef.current.clientWidth);
    }
  }, [value, hiddenAbsoluteElementRef.current, visibleElementRef.current]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    StyledTooltip,
    {
      element: /* @__PURE__ */ React.createElement("div", { ref: visibleElementRef, className: classes.autoAdjustedComplexTooltipElement }, value),
      title: /* @__PURE__ */ React.createElement(Box, null, tooltip),
      hideTooltip: !isOverflowed
    }
  ), /* @__PURE__ */ React.createElement("div", { ref: hiddenAbsoluteElementRef, className: classes.autoAdjustedComplexTooltipHiddenElement }, value));
};
const withAutoAdjustedComplexTooltip = (WrappedComponent) => (props) => {
  return props?.hideTooltip ? /* @__PURE__ */ React.createElement(WrappedComponent, { ...props }) : /* @__PURE__ */ React.createElement(AutoAdjustedComplexTooltip, { value: /* @__PURE__ */ React.createElement(WrappedComponent, { ...props }), tooltip: props?.tooltipLabel });
};
export {
  AutoAdjustedComplexTooltip,
  withAutoAdjustedComplexTooltip
};
//# sourceMappingURL=AutoAdjustedComplexTooltip.js.map
